import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { IgnoreAIToggleComponent } from '@tv3/containers/ai-responder/ignore-ai-toggle/ignore-ai-toggle.component'
import { AISettingsStoreModule } from '@tv3/containers/ai-responder/store/ai-settings.module'
import { AiSuggestionsIconComponent } from './ai-suggestions-icon/ai-suggestions-icon.component'
import { AiResponderDocumentsComponent } from './settings/documents/ai-responder-documents.component'

const components = [IgnoreAIToggleComponent, AiSuggestionsIconComponent, AiResponderDocumentsComponent]

const modules = [SharedModule, AISettingsStoreModule]

@NgModule({
  declarations: components,
  exports: components,
  imports: [CommonModule, ...modules],
  providers: [],
})
export class AiResponderSharedModule {}
